export const SETUP_INITIAL_FILTERS_STATE = 'SETUP_INITIAL_FILTERS_STATE';
export const ADD_FILTER_VALUE = 'ADD_FILTER_VALUE';
export const DELETE_FILTER_VALUE = 'DELETE_FILTER_VALUE';
export const SET_Q_SEARCH_FILTER = 'SET_Q_SEARCH_FILTER';
export const SET_LOCATION_FILTER = 'SET_LOCATION_FILTER';
export const SET_NEED_REFRESH_SEARCH = 'SET_NEED_REFRESH_SEARCH';
export const DELETE_ALL_FILTERS = 'DELETE_ALL_FILTERS';

export const SET_DASHBOARD_USER = 'SET_DASHBOARD_USER';
export const REFRESH_DASHBOARD_USER = 'REFRESH_DASHBOARD_USER';